<mat-dialog-content [attr.data-testid]="data.dialogContentTestId">
  @if (svgIcon) {
    <div class="custom-div-dialog-icon">
      <mat-icon [svgIcon]="svgIcon" class="custom-dialog-icon"></mat-icon>
    </div>
  }

  <h2 class="dialog-title" mat-dialog-title>{{ data.title }}</h2>

  <div>
    <p class="dialog-message" [ngClass]="data.isLongMessage ? 'long' : ''" [innerHTML]="data.message">
      {{ data.message }}
    </p>

    @if (data.subMessage) {
      <p class="dialog-message" style="margin-top: 5rem" [attr.data-testid]="testIds.dialogSubmessage">
        <b>{{ data.subMessage }}</b>
      </p>
    }

    @if (data.needInput) {
      <div class="dialog-input">
        @if (data.displayAsPlainText) {
          <p class="plain-header">{{ data.inputPlainHeader }}</p>
          <div class="plain-container">
            <p class="plain-left">{{ input }}</p>
            <div
              (click)="copyToClipboard()"
              [attr.data-testid]="testIds.copyBtn"
              (keydown.enter)="$event.preventDefault()"
              class="plain-right"
              tabindex="0">
              <mat-icon svgIcon="duplicate"></mat-icon>
              <span>Kopieren</span>
            </div>
          </div>
        } @else {
          <mat-form-field appearance="outline" class="input-field">
            <input
              [attr.data-testid]="data.inputFieldTestId"
              matInput
              [(ngModel)]="input"
              data-testid="dialog_input"
              (ngModelChange)="onInputChange($event)"
              [type]="data.showPasswordInput ? (isPasswordVisible ? 'text' : 'password') : 'text'" />

            @if (data.showPasswordInput) {
              <button mat-icon-button matSuffix (click)="togglePasswordVisibility()">
                <mat-icon [svgIcon]="isPasswordVisible ? 'eye' : 'eye-slash'"></mat-icon>
              </button>
            }
          </mat-form-field>
        }
      </div>

      @if (
        (data.showPasswordInput && passwordErrors.length > 0) ||
        (!data.showPasswordInput && input && !isConfirmAllowed())
      ) {
        @if (data.showPasswordInput && passwordErrors.length > 0) {
          <ul class="error-list">
            @for (error of passwordErrors; track error) {
              <li class="error-item">{{ error }}</li>
            }
          </ul>
        }
      }
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions [attr.data-testid]="data.dialogActionTestId">
  @if (data.cancelText) {
    <app-button (clicked)="onCancel()" [dataTestId]="data.cancelDataTestId" [text]="data.cancelText"></app-button>
  }

  <app-button
    (clicked)="onConfirm()"
    [dataTestId]="data.confirmDataTestId"
    [isPrimary]="true"
    [text]="data.confirmText"
    [mat-dialog-close]="data.needInput ? input : true"
    [isDisabled]="!!data.needInput && !isConfirmAllowed()">
  </app-button>
</mat-dialog-actions>
